import { FeedbackService } from '@services/requests/housien-services/FeedbackService';
import type { FeedbackContext, FeedbackInput } from '@services/requests/housien-models/FeedbackInput';
import { getCurrentLanguage } from '@/shared/i18n';

const AGENCY_ID_REGEX = /\/app\/agencies\/([^/]+)\//;

/**
 * Capture current navigation context for feedback diagnostics.
 */
export function captureContext(): FeedbackContext {
  const match = AGENCY_ID_REGEX.exec(window.location.pathname);
  return {
    url: window.location.href,
    pathname: window.location.pathname,
    ...(match?.[1] ? { agencyId: match[1] } : {}),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    userAgent: navigator.userAgent,
    colorScheme: 'light',
    timestamp: new Date().toISOString(),
    locale: getCurrentLanguage(),
  };
}

/**
 * Build the standard suggestion payload for the Sugestões modal.
 * @param message Free-text suggestion from the user.
 * @returns Typed FeedbackInput for POST /feedback.
 */
export function buildSuggestionFeedback(message: string): FeedbackInput {
  return {
    type: 'suggestion',
    title: 'suggestion',
    category: 'other',
    message: message || '',
    context: captureContext(),
  };
}

/**
 * Submit an improvement suggestion through the shared OpenAPI client.
 * @param message Free-text suggestion from the user.
 */
export async function submitSuggestionFeedback(message: string): Promise<void> {
  await FeedbackService.submitFeedback(buildSuggestionFeedback(message));
}
